import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import errors from './errors';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    errors,
  },
  strict: true,
});
